import React from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import {
	useDeleteAllDialogStatus,
	useIssueAttachments,
} from '@atlassian/jira-issue-attachments-base';
import { useIssueKey } from '@atlassian/jira-issue-context-service';
import { useDeletableAttachmentsCount } from '@atlassian/jira-issue-non-critical-gira-service';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';

const DeleteAllItem = () => {
	const issueKey = useIssueKey();
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [, { setDeleteAllDialogOpen }] = useDeleteAllDialogStatus();

	let deletableCount: number | undefined;
	if (ff('issue.details.gira-agg-migration-attachments_ecebe')) {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		[{ value: deletableCount }] = useDeletableAttachmentsCount(issueKey);

		// BE can temporarily return -1, so we safeguard it with `<= 0`
		if (typeof deletableCount !== 'number' || deletableCount <= 0) {
			return null;
		}
	} else {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const [{ value }] = useIssueAttachments(issueKey);
		// BE can temporarily return -1, so we safeguard it with `<= 0`
		if (typeof value.deletableCount !== 'number' || value.deletableCount <= 0) {
			return null;
		}
		deletableCount = value.deletableCount;
	}

	const onClick = () => {
		setDeleteAllDialogOpen(true);
		const analyticsEvent = createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'dropdownItem',
		});
		fireUIAnalytics(analyticsEvent, 'deleteAllAttachmentsDialog', {
			deletableCount,
		});
	};

	return (
		<DropdownItem
			key="delete-all-attachments"
			onClick={onClick}
			/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */
			testId="issue.views.issue-base.content.attachment.heading.meatballs.delete-all-item.dropdown-item"
		>
			{formatMessage(messages.deleteAll)}
		</DropdownItem>
	);
};
export default DeleteAllItem;
